import React from 'react';
import { Header } from './Header';
import QaErrorsList from './QaErrorsList';
import { Application } from 'src/constants/application.const';
import { SelectedOperationActions } from './SelectedOperationActions';
import { useAppPermission } from 'src/hooks/useAppPermission';
import styles from './QaErrors.module.less';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import { useFetchJiraId } from 'src/api/jiraReporterId';

export const QaErrors = () => {
  const [{ isAllowed }] = useAppPermission(Application.General.id, ['priv_deactivate_script']);
  const { user } = useAppStateContext();
  const { reporterId }  = useFetchJiraId(user?.userEmail || '');
  if(reporterId !== null){
    localStorage.setItem('reporterId', (reporterId));
  }

  return (
    <div className={styles.content}>
      <Header />
      <QaErrorsList scriptActivationEnabled={isAllowed} />
      <SelectedOperationActions />
    </div>
  );
};
